import {
  AlertRead,
  GetAlertSystemList,
  GetAlertUserList,
} from "store/api/user";
import { Box, IconButton, styled } from "@mui/material";
import { useEffect, useState } from "react";

import React from "react";
import UserAlert from "./UserAlert";
import http from "config/http";
import useNotify from "hooks/useNotify";

function SystemAlerts() {
  const notify = useNotify();

  const [systemErrors, setSystemErrors] = useState();
  const [userErrors, setUserErrors] = useState();

  const getAlertSystemList = async () => {
    try {
      const { data } = await http.get(GetAlertSystemList);

      setSystemErrors(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const getAlertUserList = async () => {
    try {
      const { data } = await http.get(GetAlertUserList);

      setUserErrors(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleRemoveAlert = async (id) => {
    try {
      await http.post(AlertRead, { id });

      const newAlerts = userErrors.filter((error) => error.id !== id);
      setUserErrors(newAlerts);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getAlertSystemList();
    getAlertUserList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {systemErrors && (
        <UserAlertWrapper>
          {systemErrors?.map((alert, index) => (
            <UserAlert
              key={index}
              severity={alert?.messageTypeId}
              title={alert?.title}
              description={alert?.message}
            />
          ))}
        </UserAlertWrapper>
      )}

      {userErrors && (
        <UserAlertWrapper>
          {userErrors?.map((alert, index) => (
            <UserAlert
              key={index}
              severity={alert?.messageTypeId}
              title={alert?.title}
              description={alert?.message}
              action={
                <IconButton
                  onClick={() => handleRemoveAlert(alert.id)}
                  color="inherit"
                  size="small"
                >
                  <ion-icon name="close"></ion-icon>
                </IconButton>
              }
            />
          ))}
        </UserAlertWrapper>
      )}
    </>
  );
}

const UserAlertWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  ".MuiPaper-root": {
    marginBottom: theme.spacing(0.5),
  },
}));

export default SystemAlerts;
